import PropTypes from 'prop-types';
import SourceLeadPopup from './SourceLeadPopup';

const LeadListPopup = ({ open, onClose, practiceId, leadIds, title }) => (
    <SourceLeadPopup
        open={open}
        onClose={onClose}
        practiceId={practiceId}
        leadIds={leadIds}
        status="All"
        title={title}
    />
);

LeadListPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    practiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leadIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    title: PropTypes.string,
};

LeadListPopup.defaultProps = {
    open: false,
    practiceId: null,
    leadIds: [],
    title: 'Lead Details',
};

export default LeadListPopup;
